const SurveyStatus = {
    PENDING: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    UNASSIGNED: 3,
    IN_REVISION: 4,
    AVAILABLE: 5, // Only for recurrent survey that has been saved using the "submit" button
    ALL_RECURRENT: 6, // When all surveys are recurrent
    RETURNED: 7 // On workflow phase when supervisor request review
}

export { SurveyStatus }